/**
 * PostDeleteReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostDeleteReq
 */
export interface PostDeleteReq {
  /** 帖子ID */
  id: string
  /** 删除原因 */
  reason?: string
}

/**
 * PostDeleteReq Schema
 */
export const PostDeleteReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '帖子ID',
      format: 'string',
      type: 'string',
      label: '帖子ID',
    },
    reason: {
      description: '删除原因',
      format: 'string',
      type: 'string',
      label: '删除原因',
    },
  },
  required: ['id'],
  type: 'object',
}
